import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-input-hidden',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class InputHidden extends mixins(AbstractField) {
  @Prop() readonly value: string | number;

  get model(): string | number {
    return this.value;
  }
  set model(val: string | number) {
    this.$emit('input', val);
  }

  onEnterKey() {
    this.$emit('enter-key');
  }

  // updated () { }

  // destroyed () { }
}
